/**
 * @class PackBuilder - Gestion du pack builder
 * @property {NodeList} products - Liste des produits du pack builder
 */
class PackBuilder extends HTMLElement {
  constructor() {
    super();

    this.builderArray = []; // This array belongs to this specific instance.
    this.builderArrayLength = 0;

    const progressBarContainer = document.querySelector("#pack-builder_progress");
    if (progressBarContainer) {
      this.progressBarElement = progressBarContainer.querySelector(".deployer_progress-bar");
      this.progressMarkerElements = progressBarContainer.querySelectorAll(".deployer_progress-marker");
      this.progressStepsElements = progressBarContainer.querySelectorAll(".deployer_progress-step");
      const stepsData = progressBarContainer.getAttribute("data-steps");
      const stepsArray = stepsData.split(",");

      this.progressSteps = [];
      for (var i = 0; i < stepsArray.length; i += 2) {
        this.progressSteps.push({
          quantity: parseInt(stepsArray[i]),
          reduction: parseInt(stepsArray[i + 1])
        })
      }
    }

    this.stickyBar = document.querySelector('pack-builder-sticky-bar');

    this.quantity = {
      min: parseInt(this.dataset.minQuantity),
      max: parseInt(this.dataset.maxQuantity),
    };

    this.content = {
      addedToCart: this.dataset.addedToCartContent,
      addToCart: this.dataset.addToCartContent,
      addMoreProducts: this.dataset.addMoreProductsContent,
    };

    this.button = {
      addToCart: this.querySelector('.pack-builder__selection-add-to-cart'),
    };

    this.builder = this.querySelector('.pack-builder__selection-list');
    this.products = this.querySelectorAll('.pack-builder__product');
    this.cartBuilderNotification = this.querySelector('.pack-builder__products-in-pack');

    this.steps = this.querySelectorAll('[id^="Step-"]');
  }

  connectedCallback() {
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('deployer-cart-drawer');
    this.listenEvents();
  }

  listenEvents() {
    const globalThis = this;

    this.products.forEach((product) => {
      const productButton = product.querySelector('.pack-builder__product-atc');

      product.addEventListener('change', this.updateVariant.bind(this, product));
      productButton.addEventListener('click', () => {
        this.addToBuilderArray(product), this.updateTotalSelectionPrice();
      });
    });

    this.button.addToCart.addEventListener('click', this.addToShopifyCart.bind(this));

    if (this.stickyBar) {
      document.addEventListener('scroll', function (e) {
        globalThis.toggleShowElementsOnScroll();
      });
    }
  }

  toggleShowElementsOnScroll() {
    if (this.elementInViewport(this.querySelector('.pack-builder__section-wrapper')))
      this.stickyBar.classList.remove('hidden');
    else
      this.stickyBar.classList.add('hidden');
  }

  elementInViewport(element) {
    var top = element.offsetTop;
    var height = element.offsetHeight;

    while (element.offsetParent) {
      element = element.offsetParent;
      top += element.offsetTop;
    }
    return top < window.scrollY + window.innerHeight && top + height > window.scrollY;
  }

  updateVariant(product) {
    const buttonAddToPack = product.querySelector('.pack-builder__product-atc');
    const selectedOption = product.querySelector('select option:checked');
    const variantPrice = product.querySelector('.pack-builder__product-price');

    buttonAddToPack.dataset.id = selectedOption.dataset.id;
    buttonAddToPack.disabled = false;
    variantPrice.textContent = selectedOption.dataset.price + '€';

    if (selectedOption.dataset.a11y === 'false') {
      buttonAddToPack.disabled = true;
    }
  }

  updateTotalSelectionPrice() {
    const total_price = this.querySelector('.pack-builder__selection-total-price');
    const total_compare_at_price = this.querySelector('.pack-builder__selection-total-compare-at-price');

    let discount_percentage = 0;

    this.steps.forEach((step) => {
      if (parseInt(step.dataset.stepQuantity) <= this.builderArrayLength)
        discount_percentage = parseInt(step.dataset.discountPercentage);
    });

    let total = 0;

    this.querySelectorAll('.pack-builder__selection-product button').forEach((item) => {
      total += parseFloat(item.dataset.price.replace(/[^0-9,\.]+/g, '').replace(',', '.'));
    });

    const discountFactor = 1 - discount_percentage / 100;

    let updated_total_price = total;
    let updated_total_compare_at_price = total * discountFactor;

    function setPriceContent(element, price) {
      element.innerHTML = price.toFixed(2).replace('.', ',') + ' €';
    }

    setPriceContent(total_price, updated_total_price);

    if (updated_total_compare_at_price > 0 && updated_total_compare_at_price < updated_total_price) {
      total_compare_at_price.classList.remove('hidden');
      total_price.classList.add('override');
      setPriceContent(total_compare_at_price, updated_total_compare_at_price);
    }
    else {
      total_price.classList.remove('override');
      total_compare_at_price.classList.add('hidden');
      setPriceContent(total_compare_at_price, 0);
    }
  }

  createHTMLListElement(product) {
    const productTitle = product.querySelector('.pack-builder__product-title').textContent;
    const productSelectedVariant = product.querySelector('.pack-builder__product option:checked').textContent;
    const productImage = product.querySelector('.pack-builder__product-image img').src;
    const productSelectedVariantId = product.querySelector('.pack-builder__product-atc').dataset.id;
    const productPrice = product.querySelector('.pack-builder__product-price').textContent;

    const productHTML = `
        <li class="pack-builder__selection-product">
          <button class="pack-builder__selection-remove" data-id="${productSelectedVariantId}" data-price="${productPrice}" onclick="this.disabled=true;this.closest('pack-builder').removeProduct(this);">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
          </button>
          <div class="pack-builder__selection-product-image">
            <img src="${productImage}" alt="${productTitle}">
          </div>
          <span class="pack-builder__selection-product-info">${productTitle} ${productSelectedVariant.trim() != "Default Title" ? productSelectedVariant : ''}</span>
        </li>
      `;

    this.builder.insertAdjacentHTML('beforeend', productHTML);
  }

  addToShopifyCart() {

    window.igEvents = window.igEvents || [];
    window.igEvents.push({ "event": "Ajout de la sélection au panier" });

    const formData = {
      items: this.builderArray,
      sections: this.getSectionsToRender().map((section) => section.id),
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        //console.log(response)
        setTimeout(async () => {
          await this.cart.renderCartContents(response)
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }

  getSectionsToRender() {
    const cartContainerSectionId = window.deployerAdapter.cartIcon.closest(".shopify-section").id.replace("shopify-section-", "");
    return [
      {
        id: "deployer-cart-drawer",
        section: "deployer-cart-drawer",
        selector: ".deployer-cart-drawer__inner",
      },
      {
        id: cartContainerSectionId,
        section: cartContainerSectionId,
        selector: window.deployerAdapter.cartIconSelector,
      },
    ];
  }

  removeProduct(buttonElement) {
    this.removeFromBuilderArray(buttonElement);
    this.toggleHideProductsButton(true);
    this.cartBuilderNotificationTrigger();
    this.updateTotalSelectionPrice();

    setTimeout(() => {
      this.toggleHideProductsButton(false);
    }, 1000);
  }

  toggleHideProductsButton(hide = false) {
    this.products.forEach((product) => {
      if (hide) {
        const button = product.querySelector('.pack-builder__product-atc');
        button.disabled = true;
      }
      else {
        const button = product.querySelector('.pack-builder__product-atc');
        button.dataset.available === 'false' ? (button.disabled = true) : (button.disabled = false);
      }
    });
  }

  addToBuilderArray(product) {
    this.toggleHideProductsButton(true);

    const productButton = product.querySelector('.pack-builder__product-atc');
    if (!productButton.classList.contains('disabled'))
      productButton.innerHTML = this.content.addedToCart;

    const productId = parseInt(productButton.dataset.id);
    const existingProduct = this.builderArray.find((item) => item.id === productId);

    if (this.builderArrayLength < this.quantity.max || this.quantity.max == 0) {
      if (existingProduct) {
        existingProduct.quantity += 1;
        this.builderArrayLength += 1;
      }
      else {
        this.builderArray.push({
          id: productId,
          quantity: 1,
          properties: {
            _packBuilder: true,
          },
          sections: this.getSectionsToRender().map((section) => section.id),
        });
        this.builderArrayLength += 1;
      }

      setTimeout(() => {
        productButton.innerHTML = this.content.addToCart;
        this.toggleHideProductsButton(false);
      }, 1000);

      this.createHTMLListElement(product);
    }

    if (this.quantity.max > 0)
      this.maxQuantityTrigger();
    else {
      this.toggleAddToCartButton();
      this.cartBuilderNotificationTrigger();
    }

    if (this.progressBarElement)
      this.updateProgressBar(this.builderArrayLength);
  }

  removeFromBuilderArray(buttonElement) {
    const productId = parseInt(buttonElement.dataset.id);
    const existingProductIndex = this.builderArray.findIndex((product) => product.id === productId);

    if (existingProductIndex !== -1) {
      const existingProduct = this.builderArray[existingProductIndex];
      existingProduct.quantity -= 1;
      this.builderArrayLength -= 1;

      if (existingProduct.quantity == 0) {
        this.builderArray.splice(existingProductIndex, 1);
      }
    }

    this.querySelectorAll('.pack-builder__selection-product button').forEach((button) => {
      button.disabled = true;
    });

    buttonElement.closest('.pack-builder__selection-product').remove();

    setTimeout(() => {
      this.querySelectorAll('.pack-builder__selection-product button').forEach((button) => {
        button.disabled = false;
      });
    }, 1000);

    if (this.quantity.max > 0)
      this.maxQuantityTrigger();
    else {
      this.toggleAddToCartButton();
      this.cartBuilderNotificationTrigger();
    }

    if (this.progressBarElement)
      this.updateProgressBar(this.builderArrayLength);
  }

  cartBuilderNotificationTrigger() {
    let shouldStop = false;
    const stepsArray = Array.from(this.steps);
    const maxQuantity = this.quantity.max || Math.max(...stepsArray.map(step => parseInt(step.dataset.stepQuantity)));
    const textFinal = this.dataset.textFinal;
    let textTemplate = this.dataset.stepText;

    stepsArray.some((step, stepIndex) => {
      const currentQuantity = parseInt(step.dataset.stepQuantity);
      const currentDiscount = parseInt(step.dataset.discountPercentage);

      let nextStepQuantity = 0;
      let nextStepDiscount = 0;

      if (stepIndex < stepsArray.length - 1) {
        const nextStep = stepsArray[stepIndex + 1];
        nextStepQuantity = parseInt(nextStep.dataset.stepQuantity);
        nextStepDiscount = parseFloat(nextStep.dataset.discountPercentage);
      }

      const remainingQuantity = currentQuantity - this.builderArrayLength;

      if (this.builderArrayLength >= maxQuantity) {
        this.cartBuilderNotification.innerHTML = textFinal;
        shouldStop = true;
      }
      else if (remainingQuantity > 0) {
        let text = textTemplate
          .replace('||count||', remainingQuantity)
          .replace('||discount||', currentDiscount);
        this.cartBuilderNotification.innerHTML = text;
        shouldStop = true;
      }

      if (shouldStop) return true;
    });

    this.dispatchEvent(new CustomEvent('pack-builder:change', { detail: { content: this.cartBuilderNotification.innerHTML } }));
  }

  maxQuantityTrigger() {
    if (this.builderArrayLength >= this.quantity.max) {
      this.products.forEach((product) => {
        const productButton = product.querySelector('.pack-builder__product-atc');
        productButton.setAttribute('disabled', true);
        productButton.classList.add('disabled');
      });
    }
    else {
      this.products.forEach((product) => {
        const productButton = product.querySelector('.pack-builder__product-atc');
        if (productButton.getAttribute('disabled')) {
          productButton.removeAttribute('disabled');
          productButton.classList.remove('disabled');
        }
      });
    }

    this.toggleAddToCartButton();
    this.cartBuilderNotificationTrigger();
  }

  toggleAddToCartButton() {
    if (this.builderArrayLength >= this.quantity.min) {
      this.button.addToCart.removeAttribute('disabled');
      this.button.addToCart.innerHTML = this.button.addToCart.dataset.addToCart;
    }
    else {
      this.button.addToCart.setAttribute('disabled', true);
      this.button.addToCart.innerHTML = this.content?.addMoreProducts;
    }
  }

  updateProgressBar(nbElements) {
    if (!this.progressSteps)
      return;

    const nonEmptySteps = this.progressSteps.filter(step => !isNaN(step.reduction) && step.reduction !== 0);

    if (nonEmptySteps.length > 0) {
      const sortedSteps = nonEmptySteps.sort((a, b) => b.quantity - a.quantity);
      const totalMarkers = this.progressMarkerElements.length;

      let closestMarkerIndex = -1;
      for (let i = 0; i < totalMarkers; i++) {
        const markerStep = parseInt(this.progressMarkerElements[i].dataset.step);
        if (nbElements > markerStep) {
          closestMarkerIndex = i;
          break;
        }
      }

      const currentMarker = this.progressMarkerElements[closestMarkerIndex];
      const nextMarker = this.progressMarkerElements[closestMarkerIndex + 1];

      const currentStep = currentMarker ? parseInt(currentMarker.dataset.step) : 0;
      const nextStep = nextMarker ? parseInt(nextMarker.dataset.step) : sortedSteps[sortedSteps.length - 1].quantity;

      const currentLeft = currentMarker ? parseFloat(currentMarker.style.left.replace('%', '')) : 0;
      const nextLeft = nextMarker ? parseFloat(nextMarker.style.left.replace('%', '')) : 100;

      const range = nextLeft - currentLeft;
      const progressInRange = closestMarkerIndex == -1 ? nbElements : nbElements - currentMarker.dataset.step;

      let percentage = currentLeft + (range / (nextStep - currentStep)) * progressInRange;

      if (nbElements >= sortedSteps[0].quantity)
        percentage = 100;

      const percentageValue = parseFloat(percentage);

      if (!isNaN(percentageValue) && isFinite(percentageValue))
        this.progressBarElement.style.width = `${percentageValue}%`;
      else
        console.error("Invalid percentage value:", percentage);

      this.progressMarkerElements.forEach((marker) => {
        if (marker.dataset.step <= nbElements)
          marker.classList.add('active')
        else
          marker.classList.remove('active')
      })

      this.progressStepsElements.forEach((marker) => {
        if (marker.dataset.step <= nbElements)
          marker.classList.add('active')
        else
          marker.classList.remove('active')
      })
    }
    else {
      this.progressBarElement.style.width = '0%';
    }
  }
}

customElements.define('pack-builder', PackBuilder);

class PackBuilderStickyBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.listenEvents();
  }

  listenEvents() {
    this.closest('pack-builder').addEventListener('pack-builder:change', (event) => {
      this.updateContent(event.detail.content);
    });
  }

  updateContent(content) {
    this.querySelector('.pack-builder-sticky-bar__content').innerText = content;
    this.classList.contains('hidden') ? this.classList.remove('hidden') : null;
  }
}

customElements.define('pack-builder-sticky-bar', PackBuilderStickyBar);